var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.857 3.38v2.115h2.616l-.414 2.848H5.857v6.564a9.843 9.843 0 01-2.907-.03V8.342H.538V5.495H2.95V2.907A2.907 2.907 0 015.858 0v.001L5.87 0h2.603v2.464h-1.7a.916.916 0 00-.916.915l-.001.001z",
    fill: "#1C2631"
  })));
}

export default SvgFacebookinline;